// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__St0Yc"};